import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';

import App from './App';
import ModalProvider from './contexts/modal';
import ModalInfoProvider from './contexts/modalInfo';
import { DeviceProvider } from './contexts/deviceContext';
import { MapProvider } from './contexts/mapContext';
import { DashboardUIProvider } from './contexts/dashboardUIContext';
import { UserSubscriptionProvider } from './contexts/userSubscriptionContext';
import reportWebVitals from './reportWebVitals';
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/theme';
import './config/apiInterceptors';
import LoadingPage from './components/LoadingPage';
import ErrorBoundary from './components/ErrorBoundary';
import ApiErrorListener from './components/ApiErrorListener';

// Selecionando o elemento root
const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('❌ [index.jsx] ~ Elemento #root não encontrado no DOM.');
} else {
  try {
    const root = createRoot(rootElement);

    // Envolvemos a aplicação com BrowserRouter
    root.render(
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <GlobalStyles />
          <CssBaseline />
          <ModalProvider>
            <ApiErrorListener />
            <ModalInfoProvider>
              <UserSubscriptionProvider>
                <DeviceProvider>
                  <MapProvider>
                    <DashboardUIProvider>
                      <Suspense fallback={<LoadingPage />}>
                        <ErrorBoundary>
                          <App />
                        </ErrorBoundary>
                      </Suspense>
                    </DashboardUIProvider>
                  </MapProvider>
                </DeviceProvider>
              </UserSubscriptionProvider>
            </ModalInfoProvider>
          </ModalProvider>
        </BrowserRouter>
      </ThemeProvider>
    );
  } catch (error) {
    console.error('❌ [index.jsx] ~ Erro ao renderizar a aplicação:', error.message);
  }
}

// Medição de performance
reportWebVitals();
